import { render, staticRenderFns } from "./political-course.vue?vue&type=template&id=fbf22846&"
import script from "./political-course.vue?vue&type=script&lang=js&"
export * from "./political-course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports